<template>
  <div class="sidebar" :data="backgroundColor">
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <div class="logo">
        <NuxtLink to="/dashboard/" class="simple-text logo-mini">
          <img :src="logo" alt="app-logo" />
        </NuxtLink>
        <NuxtLink to="/dashboard/" class="simple-text logo-normal">
          {{ title }}
        </NuxtLink>
      </div>
      <slot></slot>
      <ul class="nav">
        <slot name="links">
          <SidebarPluginSidebarItem v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
            <SidebarPluginSidebarItem v-for="(subLink, index) in link.children" :key="subLink.name + index"
              :link="subLink">
            </SidebarPluginSidebarItem>
          </SidebarPluginSidebarItem>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script lang="ts" setup>

import {useSidebar} from "~/modules/common/stores/sidebar";
import {storeToRefs} from "pinia";

const props = defineProps({
  title: {
    type: String,
    default: '',
    description: 'Sidebar title'
  },
  shortTitle: {
    type: String,
    default: '',
    description: 'Sidebar short title'
  },
  logo: {
    type: String,
    default: '/img/mydb_logo.png',
    description: 'Sidebar app logo'
  },
  backgroundColor: {
    type: String,
    default: 'vue',
    validator: value => {
      let acceptedValues = [
        '',
        'vue',
        'blue',
        'green',
        'orange',
        'red',
        'primary'
      ];
      return acceptedValues.indexOf(value) !== -1;
    },
    description:
      'Sidebar background color (vue|blue|green|orange|red|primary)'
  },
  sidebarLinks: {
    type: Array as () => { name: string, children: any[] }[],
    default: () => [],
    description:
      "List of sidebar links as an array if you don't want to use components for these."
  },
  autoClose: {
    type: Boolean,
    default: true,
    description:
      'Whether sidebar should autoclose on mobile when clicking an item'
  }
});

provide('autoClose', props.autoClose);

const $sidebar = useSidebar();

const minimizeSidebar = () => $sidebar.toggleMinimize();

onBeforeUnmount(() => $sidebar.showSidebar && ($sidebar.displaySidebar(false)));
</script>
<style>
@media (min-width: 992px) {

  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
